// La cola de un globo de chat, como Telegram: una curva que sale de la esquina inferior del último globo de cada grupo.
// Pieza suelta (04-11) para que la usen los globos de la oficina (ConversacionOficina) y los de la ventana «Santi»
// (pelotas/piezas.tsx) sin que la ventana «Santi» cargue toda la conversación. El color, por su clase (token), nunca a mano.
import { cn } from '../../../lib/utils';

export function Cola({ lado, className, de }: { lado: 'izquierda' | 'derecha'; className: string; de: 'pau' | 'agente' }) {
  return (
    <svg
      viewBox="0 0 11 20"
      width="11"
      height="20"
      aria-hidden
      data-cola={de}
      className={cn('absolute bottom-0', lado === 'derecha' ? '-right-[8px]' : '-left-[8px] -scale-x-100', className)}
    >
      <path fill="currentColor" d="M0 0v20h11C6.5 19.2 1.4 15.6 0 9.2V0z" />
    </svg>
  );
}
